const Typewriter = require('typewriter-effect/dist/core');

function shuffle(array) {
  let currentIndex = array.length;
  let randomIndex;
  while (currentIndex != 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

function startTypewriter(lang='en') {
  if (lang === 'en') {
    translations = [
      'documents', 'photos', 'scans', 'notes', 'invoices', 'videos',
      'presentations', 'spreadsheets', 'screenshots', 'backups', 'memories', 'projects',
      'family', 'clouds', 'coworkers', 'collaborators', 'clients', 'ideas'
    ]
  } else {
    translations = [
      'dokumente', 'slike', 'skene', 'zapiske', 'račune', 'posnetke',
      'prezentacije', 'razpredelnice', /*'zajeme zaslona', 'varnostne kopije'*/, 'spomine', 'projekte',
      'sorodnike', 'oblake', 'sodelavce', 'stranke', 'ideje'
    ]
  }
  const words = shuffle(translations);

  setTimeout(function() {
    const el = $('#words');
    let counter = 10;
    const c = setInterval(function() {
      counter--;
      if (counter === 0) {
        clearInterval(c)
        new Typewriter('#words', {
          strings: words,
          autoStart: true,
          delay: 70,
          deleteSpeed: 50,
          pauseFor: 1500,
          loop: true,
        });
        return
      }
      const pt = el.text().slice(0, counter -1)
      el.html(`<span>${pt}</span><span class="Typewriter__cursor">|</span>`)
    }, 50)
  }, 2000)
};

window.startTypewriter = startTypewriter;
